export default "<div class=\"img\" [style.background-image]=\"getImg()\">\r\n    <ng-content *ngIf=\"!getImg()\"></ng-content>\r\n</div>"